import {
    SET_CURRENT_TAB_INDEX, SET_PMREQAESERV_PROJ_ID, FETCH_lkp_ProjectProgramType,
    SET_AELOOKAESERV_PROJ_ID, FETCH_lkp_QueueType_AE_FULFILLED, FETCH_lkp_StatusTracking_AE_FULFILLED,
    FETCH_lkp_Phase_AE_FULFILLED, FETCH_AE_SEARCH_RESULTS, FETCH_AE_SEARCH_RESULTS_FAILED, FETCH_lkp_ProjectType, FETCH_lkp_ProjectTypeForPb,
    FETCH_ProjectType, POST_PROJECT_TYPES, FETCH_DELAYS_GAINS, FETCH_DELAY_ATTTRIBUTED_TOS, FETCH_DELAY_PHASE_OF_OCCURRENCE,
    FETCH_DELAY_CATEGORY, FETCH_DELAY_SUBCATEGORY, FETCH_lkp_Complexity, FETCH_lkp_LeedCertification, FETCH_ComplexityAnswers, POST_ComplexityAnswers
} from '../actions/types';

const defaultState = {
    costModules: [],
    objectCodeFMS: [],
    documentCheckList: [],
    lkp_documentChkLists: [],
    documentChkListLogs: [],
    currentTabIndex: 0,
    pmReqAEServProjId: '',
    clientAgencyTitles: [],
    clientAgencies: [],
    projectTypes: [],
    projectTypesPb: [],
    designSources_AE: [],
    disciplines_AE: [],
    jobTypes_AE: [],
    queueTypes_AE: [],
    statusTracking_AE: [],
    studios_AE: [],
    phases_AE: [],
    tracks_AE: [],
    reviewStatuses_AE: [],
    trackingPhases_AE: [],
    teamLeaders_AE: [],
    otherMembers_AE: [],
    trackingMembers_AE: [],
    searchResults_AE: [],
    aeTracksMain: [],
    allMembers_AE: [],
    studioMembers_AE: [],
    membersNOstudio_AE: [],
    aeProjectsInMyQueue: [],
    selectedProject_AE: [],
    pmLogsByPhaseId_AE: [],
    pmLogsByProjectId_AE: [],
    allPayments: [],
    allChangeOrders: [],
    csbDetail: [],
    fscDetail: [],
    cmDetail: [],
    toDetail : [],
    stoDetail:[],
    cpDetail: [],
    docTypes_AE: [],
    docs_AE: [],
    allPrjPayments:[],
    allCntractData:[],
    reviewPhaseStatuses_AE: [],
    internalTeamMembers: [],
    externalTeamMembers: [],
    delaysGains: [],
    delayAttributedTos: [],
    delayPhasesOfOccurence: [],
    delayCategories: [],
    delaySubcategories: [],
    complexity: [],
    complexityAnswersSelected: [],
    leedCertification: [],
    currentPhase: ''
};

export default (state = defaultState, action = {}) => {
    switch (action.type) {
        case 'FETCH_COST_MODULE_FULFILLED':
            return {
                ...state,
                costModules: action.payload.data.entries,
            }

        case 'FETCH_OBJECT_CODE_FMS_FULFILLED':
            return {
                ...state,
                objectCodeFMS: action.payload.data.entries,
            }

        case 'FETCH_DOCUMENT_CHECKLIST_FULFILLED':
            return {
                ...state,
                documentCheckList: action.payload.data.entries,
            }

        case 'FETCH_lkp_DOCUMENT_CHECKLISTs_FULFILLED':
            return {
                ...state,
                lkp_documentChkLists: action.payload.data.entries,
            }

        case 'FETCH_DOCUMENT_CHKLIST_LOGs_FULFILLED':
            return {
                ...state,
                documentChkListLogs: action.payload.data.entries,
            }

        case 'FETCH_CLIENT_AGENCY_TITLES_FULFILLED':
            return {
                ...state,
                clientAgencyTitles: action.payload.data.entries,
            }

        case 'FETCH_CLIENT_AGENCIES_FULFILLED':
            return {
                ...state,
                clientAgencies: action.payload.data.entries,
            }

        // AE START
        case 'FETCH_lkp_DesignSource_AE_FULFILLED':
            return {
                ...state,
                designSources_AE: action.payload.data.entries,
            }

        case 'FETCH_lkp_Discipline_AE_FULFILLED':
            return {
                ...state,
                disciplines_AE: action.payload.data.entries,
            }

        case 'FETCH_lkp_JobType_AE_FULFILLED':
            return {
                ...state,
                jobTypes_AE: action.payload.data.entries,
            }

        case FETCH_lkp_QueueType_AE_FULFILLED:
            return {
                ...state,
                queueTypes_AE: action.payload.data.entries,
            }

        case FETCH_lkp_StatusTracking_AE_FULFILLED:
            return {
                ...state,
                statusTracking_AE: action.payload.data.entries,
            }

        case 'FETCH_lkp_Studio_AE_FULFILLED':
            return {
                ...state,
                studios_AE: action.payload.data.entries,
            }

        case 'FETCH_lkp_Track_AE_FULFILLED':
            return {
                ...state,
                tracks_AE: action.payload.data.entries,
            }

        case 'FETCH_lkp_ReviewStatus_AE_FULFILLED':
            return {
                ...state,
                reviewStatuses_AE: action.payload.data.entries,
            }

        case 'FETCH_lkp_ReviewPhaseStatus_AE_FULFILLED':
            return {
                ...state,
                reviewPhaseStatuses_AE: action.payload.data.entries,
            }

        case 'FETCH_TRACKING_PHASE_AE_FULFILLED':
            return {
                ...state,
                trackingPhases_AE: action.payload.data.entries,
            }

        case FETCH_lkp_Phase_AE_FULFILLED:
            return {
                ...state,
                phases_AE: action.payload.data.entries,
            }

        case 'FETCH_TEAM_LEADERS_AE_FULFILLED':
            return {
                ...state,
                teamLeaders_AE: action.payload.data.entries,
            }

        case 'FETCH_INTERNAL_TEAM_FULFILLED':
            return {
                ...state,
                internalTeamMembers: action.payload.data.entries,
            }

        case 'FETCH_EXTERNAL_TEAM_FULFILLED':
            return {
                ...state,
                externalTeamMembers: action.payload.data.entries,
            }

        case 'FETCH_OTHER_MEMBERS_AE_FULFILLED':
            return {
                ...state,
                otherMembers_AE: action.payload.data.entries,
            }

        case 'FETCH_TRACKING_MEMBERS_AE_FULFILLED':
            return {
                ...state,
                trackingMembers_AE: action.payload.data.entries,
            }

        case 'FETCH_ALL_MEMBERS_AE_FULFILLED':
            return {
                ...state,
                allMembers_AE: action.payload.data.entries,
            }

        case 'GET_AE_TRACKING_BY_PROJECTId':
            return {
                ...state,
                aeTracksMain: action.payload.data.entries,
            }

        case FETCH_AE_SEARCH_RESULTS:
            return {
                ...state,
                searchResults_AE: action.payload.data.entries,
                count_AE: action.payload.data.count,
                currentPage_AE: action.payload.data.currentPage,
                errorMessage: null
            }

        case FETCH_AE_SEARCH_RESULTS_FAILED:
            return {
                ...state,
                searchResults_AE: [],
                count_AE: 0,
                currentPage_AE: 0,
                errorMessage: 'Something went wrong. Please try again later.'   
            }
            
        case 'FETCH_MEMBERS_FOR_STUDIO_FULFILLED':
            return {
                ...state,
                studioMembers_AE: action.payload.data.entries,
            }

        case 'FETCH_MEMBERS_NO_STUDIO_AE_FULFILLED':
            return {
                ...state,
                membersNOstudio_AE: action.payload.data.entries,
            }

        case 'GET_AE_PROJECTS_BY_QUEUE':
            return {
                ...state,
                aeProjectsInMyQueue: action.payload.data.entries,
            }

        case 'SHOW_SELECTED_PROJECT_AE':
            return {
                ...state,
                selectedProject_AE: action.payload.data.entries,
            }

        case 'GET_PmLogByPhaseId_AE_FULFILLED':
            return {
                ...state,
                pmLogsByPhaseId_AE: action.payload.data.entries,
            }

        case 'GET_PmLogByProjectId_AE_FULFILLED':
            return {
                ...state,
                pmLogsByProjectId_AE: action.payload.data.entries,
            }

        case 'GET_DOC_TYPES_BY_PHASEID_AE':
            return {
                ...state,
                docTypes_AE: action.payload.data.entries,
            }

        case 'GET_DOC_BY_PROJECTID_AE':
            return {
                ...state,
                docs_AE: action.payload.data.entries,
            }
        // AE END

        case SET_CURRENT_TAB_INDEX:
            return {
                ...state,
                currentTabIndex: action.currentTabIndex
            }

        case SET_PMREQAESERV_PROJ_ID:
            return {
                ...state,
                pmReqAEServProjId: action.pmReqAEServProjId
            }

        case SET_AELOOKAESERV_PROJ_ID:
            return {
                ...state,
                aeLookAEServProjId: action.aeLookAEServProjId
            }

        case FETCH_lkp_ProjectProgramType:
            return {
                ...state,
                projectProgramTypes: action.payload.data.entries,
            }

        case FETCH_lkp_ProjectType:
            return {
                ...state,
                projectTypes: action.payload.data.entries,
            }

        case FETCH_lkp_ProjectTypeForPb:
            return {
                ...state,
                projectTypesPb: action.payload.data.entries,
            }

        case FETCH_ProjectType:
            return {
                ...state,
                projectTypesSelected: action.payload.data.entries,
            }

        case POST_PROJECT_TYPES:
            return {
                ...state,
                projectTypesSelected: action.payload
            }


        case 'FETCH_CONTRACT_PAYMENTS':
            return {
                ...state,
                allPayments: action.payload.data.entries,
            }

        case 'FETCH_CONTRACT_CHANGE_ORDERS':
            return {
                ...state,
                allChangeOrders: action.payload.data.entries,
            }
        case 'FETCH_CONTRACT_CSB_DETAILS':
            return {
                ...state,
                csbDetail: action.payload.data.entries,
            }
        case 'FETCH_CONTRACT_FS_DETAILS':
            return {
                ...state,
                fscDetail: action.payload.data.entries,
            }
        case 'FETCH_CONTRACT_CM_DETAILS':
            return {
                ...state,
                cmDetail: action.payload.data.entries,
            }

        case 'FETCH_CONTRACT_TO_DETAILS':
            return {
                ...state,
                toDetail: action.payload.data.entries,
            }
        case 'FETCH_CONTRACT_STO_DETAILS':
            return {
                ...state,
                stoDetail: action.payload.data.entries,
            }

        case 'FETCH_CPTRACK_DETAILS':
            return {
                ...state,
                cpDetail: action.payload.data.entries,
            }
        case 'FETCH_PROJECT_PAYMENTS':
            return {
                ...state,
                allPrjPayments: action.payload.data.entries,
            }
        case 'FETCH_PROJECT_CONTRACT_DATA':
            return {
                ...state,
                allCntractData: action.payload.data.entries,
            }
        // Delay Log dropdowns start
        case FETCH_DELAYS_GAINS:
            return {
                ...state,
                delaysGains: action.payload.data.entries,
            }
        case FETCH_DELAY_ATTTRIBUTED_TOS:
            return {
                ...state,
                delayAttributedTos: action.payload.data.entries,
            }
        case FETCH_DELAY_PHASE_OF_OCCURRENCE:
            return {
                ...state,
                delayPhasesOfOccurence: action.payload.data.entries,
            }
        case FETCH_DELAY_CATEGORY:
            return {
                ...state,
                delayCategories: action.payload.data.entries,
            }
        case FETCH_DELAY_SUBCATEGORY:
            return {
                ...state,
                delaySubcategories: action.payload.data.entries,
            }
        // Delay Log dropdowns end

        // Project complexity start
        case FETCH_lkp_Complexity:
            return {
                ...state,
                complexity: action.payload.data.entries,
            }
        case FETCH_lkp_LeedCertification:
            return {
                ...state,
                leedCertification: action.payload.data.entries,
            }
        case FETCH_ComplexityAnswers:
            return {
                ...state,
                complexityAnswersSelected: action.payload.data.entries,
            }
        case POST_ComplexityAnswers:
            return {
                ...state,
                complexityAnswersSelected: action.payload
            }
        // Project complexity end
        default:
            return state;
    }
}